import React from 'react';
import { Pagination as PaginationComponent } from 'react-admin';

const Pagination = (props) => <PaginationComponent rowsPerPageOptions={[]} {...props} />;

export default Pagination;
